import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import md5 from "js-md5";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { Loading } from "element-ui";
// import "../src/assets/style/"; /*解决浏览器差异问题*/
import "../src/assets/style/reset.css";
import "../src/assets/style/base.css";
import "../src/assets/style/iconfont/iconfont.css";
import 'amfe-flexible'
import commonApi from "./util/commonApi";
// this.$commonApi.myMessage(name + '减少慧泉章X1', 2, 2000)

Vue.prototype.$commonApi = commonApi;
const url = process.env.VUE_APP_URL;
Vue.prototype.$url = url;
Vue.prototype.$md5 = md5;
Vue.prototype.openLoading = function() {
	const loading = Loading({
		// 声明一个loading对象
		lock: true, // 是否锁屏
		text: "正在加载...", // 加载动画的文字
		spinner: "el-icon-loading", // 引入的loading图标
		background: "rgba(0, 0, 0, 0.3)", // 背景颜色
		target: ".sub-main", // 需要遮罩的区域
		body: true,
		customClass: "mask", // 遮罩层新增类名
	});
	setTimeout(function() {
		// 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
		loading.close(); // 关闭遮罩层
	}, 5000);
	return loading;
};
/**调用方法
 * 开始加载动画 const rLoading = this.openLoading();
 * 结束加载动画 rLoading.close();
 */

Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");

//全局路由守卫
// router.beforeEach((to, from, next) => {
//     if(to.path == "/Courselist/myCourses" && from.path == "/main"){
//         // location.reload();
//         next();
//     }
//     next();
// })
